import React from "react";

// Message « l'app a évolué » pour les membres existants (1 fois) : les invite à vérifier /
// mettre à jour leur profil (nouvelle taxonomie Particulier/Pro). Non bloquant, dismissable.
// Autonome (aucune dépendance app) pour rester robuste ; rouge de marque en dur.

const I18N = {
  fr: { title:"HorseConnex a évolué ! 🐴", body:"On a amélioré les profils (particulier / pro et métiers). Prends 30 secondes pour vérifier le tien et le mettre à jour si besoin.", update:"Mettre à jour mon profil", later:"Plus tard" },
  en: { title:"HorseConnex has evolved! 🐴", body:"We've improved profiles (individual / pro and professions). Take 30 seconds to check yours and update it if needed.", update:"Update my profile", later:"Later" },
  de: { title:"HorseConnex hat sich weiterentwickelt! 🐴", body:"Wir haben die Profile verbessert (Privat / Profi und Berufe). Nimm dir 30 Sekunden, um deins zu prüfen und ggf. zu aktualisieren.", update:"Mein Profil aktualisieren", later:"Später" },
  es: { title:"¡HorseConnex ha evolucionado! 🐴", body:"Hemos mejorado los perfiles (particular / pro y profesiones). Tómate 30 segundos para revisar el tuyo y actualizarlo si hace falta.", update:"Actualizar mi perfil", later:"Más tarde" },
  it: { title:"HorseConnex si è evoluto! 🐴", body:"Abbiamo migliorato i profili (privato / pro e professioni). Prenditi 30 secondi per controllare il tuo e aggiornarlo se serve.", update:"Aggiorna il mio profilo", later:"Più tardi" },
  pt: { title:"O HorseConnex evoluiu! 🐴", body:"Melhorámos os perfis (particular / pro e profissões). Leva 30 segundos para veres o teu e atualizá-lo se precisares.", update:"Atualizar o meu perfil", later:"Mais tarde" },
  nl: { title:"HorseConnex is vernieuwd! 🐴", body:"We hebben de profielen verbeterd (particulier / pro en beroepen). Het duurt 30 seconden om het jouwe te bekijken en bij te werken indien nodig.", update:"Mijn profiel bijwerken", later:"Later" },
};

export default function EvolvedNotice({ lang = "fr", onUpdate, onDismiss }) {
  const t = I18N[lang] || I18N.fr;
  return (
    <div onClick={onDismiss} style={{
      position:"fixed", inset:0, zIndex:2000, background:"rgba(0,0,0,.6)",
      display:"flex", alignItems:"center", justifyContent:"center", padding:20,
    }}>
      <div onClick={e=>e.stopPropagation()} style={{
        width:"100%", maxWidth:380, background:"#1A1A2E", color:"#fff",
        borderRadius:18, padding:"22px 20px 18px", border:"1px solid rgba(255,255,255,.12)",
        boxShadow:"0 20px 50px rgba(0,0,0,.5)", textAlign:"center",
      }}>
        <div style={{ fontSize:19, fontWeight:900, fontFamily:"var(--fh)", marginBottom:10 }}>{t.title}</div>
        <div style={{ fontSize:13.5, color:"rgba(255,255,255,.75)", lineHeight:1.6, marginBottom:20 }}>{t.body}</div>
        <button onClick={onUpdate} style={{
          width:"100%", padding:"13px 20px", borderRadius:13, border:"none", cursor:"pointer",
          background:"#C8001A", color:"#fff", fontSize:15, fontWeight:800, fontFamily:"var(--fh)",
          boxShadow:"0 8px 22px rgba(200,0,26,.45)", marginBottom:10,
        }}>{t.update}</button>
        <button onClick={onDismiss} style={{
          width:"100%", padding:"11px 20px", borderRadius:13, cursor:"pointer",
          background:"transparent", color:"rgba(255,255,255,.55)", fontSize:13, fontWeight:600,
          border:"1px solid rgba(255,255,255,.15)",
        }}>{t.later}</button>
      </div>
    </div>
  );
}
